export default {"src":"/_next/static/media/honda.ff032b91.svg","height":62,"width":176,"blurWidth":0,"blurHeight":0};